import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import MainNavbar from '../layouts/header/MainNavbar';
import Footer from '../layouts/footer/Footer';
import Announcment from '../components/Announcment';
import CustomerSidebar from '../layouts/main/CustomerSidebar'
import MyAccount from '../components/customer/MyAccount';
import AddressBook from '../components/AddressBook';
import OrderHistory from '../components/customer/OrderHistory';
import CustomerDetails from '../components/CustomerDetails';


const Container = styled.div`
    padding-top:70px;
    display:flex;
    @media only screen and (max-width:768px){
        display:block;
    }
`
const Left = styled.div`
    flex:1;
    background-color: #f1f1f1;
`;
const Right = styled.div`
    flex:3;
    margin-bottom: 80px;
`;
const ABDiv = styled.div`
@media only screen and (min-width:400px){
  max-width: 70%;
}
`
const OHDiv = styled.div`
  @media only screen and (min-width:400px){
    padding:20px;
}
`
const VisuallyHidden = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
const Customer = () => {
    const { t } = useTranslation();
    const {details} = useParams()
    const [selectedDetail, setSelectedDetail] = useState(null);

  // Ažurirajte odabrani detalj kada se promeni details parametar
  useEffect(() => {
    setSelectedDetail(details);
  }, [details]);

  // Funkcija za renderovanje odgovarajuće komponente na osnovu odabranog detalja
  const renderDetailComponent = () => {
    switch (selectedDetail) {
      case 'moj-nalog':
        return <MyAccount />;
      case 'adresar':
        return <ABDiv><AddressBook/></ABDiv>;
      case 'moji-detalji':
        return <CustomerDetails />;
      case 'istorija-narudzbina':
        return <OHDiv><OrderHistory /></OHDiv>;
      default:
        return null;
    }
  };
  return (
      <>
      <Helmet>
        <title>Moj nalog | Snus Srbija</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <MainNavbar/>
    <VisuallyHidden>{t('AccountDropDown.ACCOUNT')}</VisuallyHidden>
    <Container>
        <Left as="nav" aria-label="Nalog - navigacija">
            <CustomerSidebar/>
        </Left>
        <Right as="main">
        <div>{renderDetailComponent()}</div>
        </Right>

    </Container>
    <Footer/>
    </>
  )
}

export default Customer